(function () {
  const MOBILE_MQ = window.matchMedia("(max-width: 989px)");

  function syncInfoMedia(root) {
    const tableCol = root.querySelector(".ppc-specs-info-table-col");
    const media = root.querySelector(".ppc-specs-info-media");
    if (!tableCol || !media) return;

    if (!MOBILE_MQ.matches) {
      root.style.removeProperty("--ppc-info-square-size");
      return;
    }

    const tableHeight = tableCol.getBoundingClientRect().height;
    const maxSide = Math.min(window.innerWidth * 0.56, 224);
    const size = Math.round(Math.min(tableHeight * 0.78, maxSide));
    if (size > 0) {
      root.style.setProperty("--ppc-info-square-size", `${size}px`);
    }
  }

  function initRoot(root) {
    if (root.dataset.ppcInfoSyncInit === "true") return;
    root.dataset.ppcInfoSyncInit = "true";

    const tableCol = root.querySelector(".ppc-specs-info-table-col");
    if (!tableCol) return;

    const run = () => syncInfoMedia(root);
    run();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(run);
      observer.observe(tableCol);
      observer.observe(root);
    }

    const onMqChange = () => run();
    if (typeof MOBILE_MQ.addEventListener === "function") {
      MOBILE_MQ.addEventListener("change", onMqChange);
    } else if (typeof MOBILE_MQ.addListener === "function") {
      MOBILE_MQ.addListener(onMqChange);
    }

    window.addEventListener("resize", run, { passive: true });

    const image = root.querySelector(".ppc-specs-info-image");
    if (image && !image.complete) {
      image.addEventListener("load", run, { once: true });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(() => {});
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll(".ppc-specs-info").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
